class ItemTabelasExcecoesIcmsController extends AbstractController
  @$injector = [ 'pathService', '$scope', 'excecaoService','gql', 'downloadService' ]

  constructor: ($injector, $scope, pathService, @excecaoService, @gql, @downloadService)->
    super($injector)

    @itemTabela = $scope.tabData.item

    @tipos = [
      {
        id: 'isencao'
        nome: 'Isenção'
      }
      {
        id: 'reducao_base_calculo'
        nome: 'Redução base de cálculo'
      }
      {
        id: 'substituicao_tributaria'
        nome: 'Substituição tributária'
      }
      {
        id: 'tributacao_normal'
        nome: 'Tributação normal'
      }
    ]

    @loadingTracker = @promiseTracker()
    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/item-tabelas/excecoes/'

    @modalItem = @openPopup(url + 'modal/modal.html', 'excecaoModalController as ctrl', 'lg', 'static')
    @modalParecerTecnico = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/parecer-tecnico/modal.html', 'parecerTecnicoController as ctrl', 'lg', 'static')

    @listOfExcecao = []
    @filtro = {itemTabela: @itemTabela.id}

    @consultar()

  consultar: ->
    @loadingTracker.addPromise @buscarExcecoes()

  getTipoName: (identifier) ->
    @tipos.select((tipo)-> tipo.id == identifier)[0].nome

  buscarExcecoes: ->
    @excecaoService.getList(@filtro, (data)=>
      @listOfExcecao = data
    )

  clone: (excecao) ->
    copia = angular.copy excecao
    copia.id = null
    copia.itemTabela = @itemTabela.id
    copia.excecao = @tipos.select((tipo)-> tipo.id == copia.tipo)[0]

    @add(copia)

  openParecerTecnicoModal: (excecoes) ->
    @modalParecerTecnico({
      excecao: -> excecoes.id
    })

  add: (cloneData) ->
    cloneData = cloneData || { excecao: @tipos[3], itemTabela: @itemTabela.id }
    @modalItem({
      excecao: => cloneData
      tipos: => @tipos
    }, (result) =>
      @buscarExcecoes())

  edit: (excecao) ->
    excecao.excecao = @tipos.select((tipo)-> tipo.id == excecao.tipo)[0]

    @modalItem({
      excecao: => angular.copy excecao
      tipos: => @tipos
    }, (result) =>
      @buscarExcecoes())

  remover: (item)->
    Confirm.warning("Atenção", "Deseja realmente remover essa exceção Nº <strong>#{item.id}</strong>? Esta ação <strong>não poderá</strong> ser desfeita.", {
        "Não": null
        "Sim": =>
          @excecaoService.delete(item.id, (data)=>
            Alert.success("Exceção Nº <strong>#{item.id}</strong> removida com sucesso.", 'Sucesso!')
            @buscarExcecoes()
          )
      }
    )

angular.module("eficienciaFiscalModule").controller('itemTabelasExcecoesIcmsController', ItemTabelasExcecoesIcmsController)

class ExcecaoModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'excecaoService', 'convenioIcmsService', 'eflService', 'regraValidacaoService', 'excecao', 'tipos' ]

  constructor: ($injector, @modalInstance, @excecaoService, @convenioIcmsService, @eflService, @regraValidacaoService, @excecao, @tipos)->
    super($injector)

    @excecao.possuiCodigoBarras = false unless @excecao.possuiCodigoBarras

    @excecao.observacoes = [] if @excecao.observacoes == undefined

    @observacao = ''

    @convenioIcmsService.getList({}, (result) =>
      @listOfConvenio = result.data.items if result.success
    )
    @regraValidacaoService.getList({},(result) =>
      @listOfRegraValidacao = result.data.items if result.success
    )
    @submitTracker = @promiseTracker()

  addObservacao: ->
    @excecao.observacoes.push {texto: @observacao}
    @observacao = ''

  removerObservacao: (index)->
    if(index > -1)
      @excecao.observacoes.splice(index, 1)

  testarRegra: (texto = "") ->
    @eflService.test(regra: @excecao.regraExpressao, itens: texto.split("\n"), (result) =>
      @regraValidacaoTestResult = result
    )

  salvar: (form) ->
    if form.$valid
      excecao = angular.copy @excecao
      excecao.excecao = excecao.excecao.id
      excecao.regraValidacao = excecao.regraValidacao.id if excecao.regraValidacao
      @submitTracker.addPromise @excecaoService.save(excecao, (result) =>
        if result.success
          Alert.success("Exceção Nº  <strong>#{result.data.id}</strong> #{if @excecao.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
          @modalInstance.close(new Retorno(true, null, result.data))
        else
          switch result.message
            when 'regra_invalida'
              Alert.warning("""
Não foi possível <strong>#{if @excecao.id then 'atualizar' else 'criar'}</strong> a exceção, pois sua regra de validação está <strong>inválida</strong>. <br/>
Por favor, teste a regra na aba "Regra de validação" para identificar o erro e tente novamente.
""", 'Sucesso!')
            else
              Alert.warning("Não foi possível <strong>#{if @excecao.id then 'atualizar' else 'criar'}</strong> a exceção.")
      )

angular.module("eficienciaFiscalModule").controller('excecaoModalController', ExcecaoModalController)
